import type { ReactNode } from 'react';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import { cn } from '@/utils/cn';
import type { HrCalendarGranularity } from './hrCalendarUtils';

const OPTIONS: { value: HrCalendarGranularity; label: string; icon: ReactNode }[] = [
  { value: 'month', label: 'Month', icon: <CalendarViewMonthIcon sx={{ fontSize: 18 }} /> },
  { value: 'week', label: 'Week', icon: <CalendarViewWeekIcon sx={{ fontSize: 18 }} /> },
  { value: 'day', label: 'Day', icon: <CalendarViewDayIcon sx={{ fontSize: 18 }} /> },
];

export function HrCalendarGranularityToggle({
  value,
  onChange,
  className,
}: {
  value: HrCalendarGranularity;
  onChange: (g: HrCalendarGranularity) => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'inline-flex rounded-lg border border-slate-200 bg-slate-50 p-0.5 dark:border-slate-700 dark:bg-slate-800',
        className,
      )}
      role="group"
      aria-label="Calendar granularity"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={cn(
            'inline-flex items-center gap-1 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors',
            value === opt.value
              ? 'bg-white text-slate-900 shadow-sm dark:bg-slate-900 dark:text-slate-100'
              : 'text-slate-600 hover:text-slate-900 dark:text-slate-400',
          )}
          onClick={() => onChange(opt.value)}
        >
          {opt.icon}
          {opt.label}
        </button>
      ))}
    </div>
  );
}
